// src/config.js
const API_HOST = process.env.REACT_APP_API_HOST || 'https://rmrjbqbiynmxhomgbh6zpdmvju0bfcpn.lambda-url.eu-central-1.on.aws';

export default API_HOST;
